import { useState, useContext, useEffect } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from 'clsx'
import { KTSVG } from '../../../_metronic/helpers'
import { Modal } from 'react-bootstrap'
import { ComponentRequest } from '../componentLayout'
import { swlAlert } from '../sweetAlert'
import Swal from 'sweetalert2'
import { uploadCSv } from './api'
import { useParams } from 'react-router-dom'
import { downloadCsv, Loader } from '../helper'
import { csvSamples } from './csv-sample'
import { getDispatchSampleCsv, getDispatchStatus } from '../../master/fullfillment/api'

const editUserSchema = Yup.object().shape({
    uploadFile: Yup.mixed().required('A file is required')
        .test('fileFormat', 'Please upload CSV file only', (value) => {

            return value && ['text/csv'].includes(value.type)
        }),

    status_remarks: Yup.string().trim().required('Remarks is required').min(10, 'Remarks must be at least 10 characters'),
    dispatch_mode_id: Yup.string()
        .when('module_key', {
            is: 'dispatch_upload',
            then: Yup.string().required('Dispatch Mode is required'),
            otherwise: Yup.string(),
        }),
    dispatch_status_id: Yup.string()
        .when('module_key', {
            is: 'dispatch_upload',
            then: Yup.string().required('Dispatch Stage is required'),
            otherwise: Yup.string(),
        }),
    file_nick_name: Yup.string().required('File Nick Name is required'),

})

/**
 * UploadFileForm component for uploading CSV files and handling dispatch-related uploads.
 * - Renders a modal form for file upload, remarks, and dispatch options.
 * - Uses Formik and Yup for form state, validation, and submission.
 * - Handles confirmation dialog, sample file download, and API call for upload.
 */
const UploadFileForm = ({ url = null, module_type = null }) => {
    const [subStatusOptions, setStatus] = useState([])
    const { comRequest } = useContext(ComponentRequest)
    const [loader, setloader] = useState(false)
    const router = useParams();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            module_key: comRequest?.module_key || '',
            status_remarks: '',
            uploadFile: '',
            module_type: comRequest?.module_type,
            file_nick_name: "",
            //ref_id: router?.id || '' // row id
            dispatch_status_id: "",
            dispatch_mode_id: ""
        },
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting }) => {

            try {
                setSubmitting(true);
                let formData = new FormData();
                formData.append('module_key', values.module_key);
                formData.append('module_type', values.module_type);
                formData.append([values.module_key], values['uploadFile']);
                formData.append('status_remarks', values['status_remarks']);
                formData.append('ref_id', router?.id || '');
                formData.append('dispatch_status_id', values.dispatch_status_id);
                formData.append('dispatch_mode_id', values.dispatch_mode_id);
                formData.append('file_nick_name', values.file_nick_name);

                const confirmResult = await Swal.fire({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to add?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    reverseButtons: true,
                    width: '500px',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                        cancelButton: 'btn btn-secondary'
                    }
                });
                if (confirmResult.isConfirmed) {
                    setloader(true)
                    const response = await uploadCSv(formData);
                    setloader(false)
                    swlAlert(response, comRequest?.rowLink);

                } else {
                    // User clicked "Cancel," do nothing or handle as needed
                }
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        }
    })

    const confirmationPopup = (type) => {
        setIsModalOpen(type)
    }
    // const getPath = (module_key) => {
    //     const csvdata = csvSamples?.filter((item) => item?.name === module_key);
    //     if (csvdata.length > 0) {
    //         return csvdata[0]
    //     } else {
    //         return { path: '', description: '' }
    //     }
    // };
    const getPath = (module_key) => {
        // If offer is true, look for modulekey_offer
        if (comRequest?.module_type === 'offer' && module_key) {
            const offerSample = csvSamples?.find((item) => item?.name === `${module_key}_offer`);
            if (offerSample) return offerSample;
        }
        // Default: look for modulekey
        const csvdata = csvSamples?.filter((item) => item?.name === module_key);
        if (csvdata.length > 0) {
            return csvdata[0]
        } else {
            return { path: '', description: '' }
        }
    };

    const downLoadSample = (data, id) => {
        const stage = data.find((stages) => Number(stages.id) === Number(id));
        const modifiedDisplayName = stage.display_name.replace(/\s+/g, '_');
        getDispatchSampleCsv({ dispatch_status_id: id }).then((response) => {
            setloader(false)
            if (response.code === 0) {
                swlAlert(response)
            } else {
                downloadCsv({
                    data: response,
                    fileName: modifiedDisplayName,
                    fileType: 'text/csv'
                })
            }
        })
    }

    useEffect(() => {
        if (comRequest?.module_key === 'dispatch_upload') {
            getDispatchStatus('dispatch_upload').then((d) => { setStatus(d?.data) })
        }
    }, [comRequest?.module_key])

    return (<>
        <button type='button' onClick={() => confirmationPopup(true)} className={'btn btn-dark '}>
            {/* <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-2 ' /> */}
            Upload File
        </button>
        <Modal className={comRequest?.module_key === 'dispatch_upload' ? 'modal-xl' : 'modal-lg'} show={isModalOpen} onHide={() => setIsModalOpen(false)}>
            <Modal.Header className='h-20px' closeButton>  <h4 className="fw-semibold fs-5 py-1"> Upload File </h4></Modal.Header>
            <Modal.Body>
                {loader && <Loader />}
                <div className='px-5'>
                    <form id="upload_file"
                        className="form fv-plugins-bootstrap5 fv-plugins-framework"
                        onSubmit={formik.handleSubmit}
                        noValidate>
                        <div className="card-body pt-3">

                            {comRequest?.module_key === 'dispatch_upload' ?
                                <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-10">
                                    <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-warning me-5' />
                                    <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                        <div className="mb-3 mb-md-0 fw-semibold">
                                            <h5 className="text-gray-900 fw-semibold">We need your attention!</h5>
                                            <div className="fs-7 text-gray-700 pe-7">Know Your Customer is a process that  businesses  use to verify and identify their customers</div>
                                        </div>

                                    </div>
                                </div>
                                : <>
                                    {getPath(comRequest.module_key || null).path &&
                                        <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-6">
                                            <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="currentColor"></path>
                                                    <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="currentColor"></path>
                                                </svg>
                                            </span>

                                            <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                                <div className="mb-3 mb-md-0 fw-semibold">
                                                    <h5 className="text-gray-900 fw-semibold">Download  Sample File</h5>
                                                    <div className="fs-7 text-gray-700 pe-7">
                                                        {getPath(comRequest.module_key || null).description}
                                                    </div>
                                                </div>

                                                <a href={getPath(comRequest.module_key || null).path || '#'}
                                                    className="btn btn-sm btn-primary px-6 align-self-center text-nowrap" download>
                                                    <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-2' />
                                                    Download
                                                </a>

                                            </div>

                                        </div>
                                    } </>}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                                            File Nick Name for Reference
                                        </label>
                                        <div className="col-lg-12 fv-row">
                                            <input
                                                type="text"
                                                name="file_nick_name"
                                                className={clsx(
                                                    'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                    {
                                                        'is-invalid':
                                                            formik.touched.file_nick_name && formik.errors.file_nick_name,
                                                    },
                                                    {
                                                        'is-valid':
                                                            formik.touched.file_nick_name && !formik.errors.file_nick_name,
                                                    }
                                                )}
                                                placeholder="Enter File Nick Name for Reference"
                                                onChange={formik.handleChange}
                                                value={formik.values.file_nick_name || ''}
                                            />

                                            {formik.touched.file_nick_name && formik.errors.file_nick_name ? (
                                                <div className="fv-plugins-message-container">
                                                    <div className="fv-help-block">
                                                        <span className="text-danger" role="alert">
                                                            {formik.errors.file_nick_name}
                                                        </span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="text-muted fs-7"></div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {comRequest?.module_key === 'dispatch_upload' &&
                                <>
                                    <div className='row'>
                                        <div className="col-lg-4 col-xl-4">
                                            <div className='row'>
                                                <label className="col-lg-12 col-form-label required fw-semibold fs-6">Dispatch Mode </label>
                                                <div className="col-lg-12 fv-row fv-plugins-icon-container">
                                                    <select
                                                        {...formik.getFieldProps('dispatch_mode_id')}
                                                        className="form-select form-select-solid rounded-0 form-select-md"
                                                        aria-label="Select Dispatch Mode"
                                                    >
                                                        <option value="">Select Dispatch Mode</option>
                                                        {subStatusOptions?.mode?.map((item) => (
                                                            <option key={item.id} value={item.id}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {formik.touched.dispatch_mode_id && formik.errors.dispatch_mode_id ? (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>
                                                                <span className='text-danger' role='alert'>{formik.errors.dispatch_mode_id}</span>
                                                            </div>
                                                        </div>
                                                    ) : <div className="text-muted fs-7"></div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-xl-4">
                                            <div className='row'>
                                                <label className="col-lg-12 col-form-label required fw-semibold fs-6">Dispatch Status</label>
                                                <div className="col-lg-12 fv-row fv-plugins-icon-container">
                                                    <select
                                                        {...formik.getFieldProps('status')}
                                                        className="form-select form-select-solid rounded-0 form-select-md"
                                                        aria-label="Select Status"
                                                    >
                                                        <option value="">Select Status</option>
                                                        {formik.values.dispatch_mode_id &&
                                                            Object.keys(subStatusOptions?.status?.[formik.values.dispatch_mode_id] || {}).map((status) => (
                                                                <option key={status} value={status}>
                                                                    {status}
                                                                </option>
                                                            ))}

                                                    </select>
                                                    {formik.touched.status && formik.errors.status ? (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>
                                                                <span className='text-danger' role='alert'>{formik.errors.status}</span>
                                                            </div>
                                                        </div>
                                                    ) : <div className="text-muted fs-7"></div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-xl-4">
                                            <div className='row'>
                                                <label className="col-lg-12 col-form-label required fw-semibold fs-6">Dispatch Stage</label>
                                                <div className="col-lg-12 fv-row fv-plugins-icon-container">
                                                    <select
                                                        {...formik.getFieldProps('dispatch_status_id')}
                                                        className="form-select form-select-solid rounded-0 form-select-md"
                                                        aria-label="Select Dispatch Stage"
                                                    >
                                                        <option value="">Select Stage</option>
                                                        {formik.values.dispatch_mode_id &&
                                                            formik.values.status &&
                                                            (subStatusOptions?.status?.[formik.values.dispatch_mode_id]?.[formik.values.status] || []).map((subStatus, index) => (
                                                                <option key={index} value={subStatus?.id}>
                                                                    {subStatus?.status}
                                                                </option>
                                                            ))}
                                                    </select>
                                                    {formik.touched.dispatch_status_id && formik.errors.dispatch_status_id ? (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>
                                                                <span className='text-danger' role='alert'>{formik.errors.dispatch_status_id}</span>
                                                            </div>
                                                        </div>
                                                    ) : <div className="text-muted fs-7"></div>}
                                                </div>

                                                {/* <button  type="button" onClick={() => downLoadSample(subStatusOptions?.status?.[formik.values.dispatch_mode_id]?.[formik.values.status], formik.values.dispatch_status_id)}
                                                    className="btn btn-sm btn-primary px-6 align-self-center text-nowrap">
                                                    <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-2' />
                                                    Download Sample File
                                                </button> */}


                                            </div>
                                        </div>

                                    </div>

                                </>

                            }
                            <div className="row">
                                <div className={comRequest?.module_key === 'dispatch_upload' ? 'col-lg-8' : 'col-lg-12'}>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">Upload</label>
                                    <div className="row">
                                        <div className="col-lg-12 fv-row">
                                            <input
                                                type='file'
                                                onChange={(e) => { formik.setFieldValue('uploadFile', e.currentTarget.files[0]) }}
                                                className={clsx(
                                                    'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                    { 'is-invalid': formik.touched.uploadFile && formik.errors.uploadFile },
                                                    { 'is-valid': formik.touched.uploadFile && !formik.errors.uploadFile, }
                                                )}
                                                autoComplete='off'
                                                disabled={formik.isSubmitting}
                                            />
                                            {/*end::Input*/}
                                            {formik.touched.uploadFile && formik.errors.uploadFile ? (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span className='text-danger' role='alert'>{formik.errors.uploadFile}</span>
                                                    </div>
                                                </div>
                                            ) : <div className="text-muted fs-7"></div>}

                                        </div>
                                    </div>
                                </div>
                                {comRequest?.module_key === 'dispatch_upload' &&
                                    <div className="col-lg-4">
                                        <label className="col-lg-4 col-form-label  fw-semibold fs-6"></label>
                                        <div className="row">
                                            <div className="col-lg-12 mt-4 fv-row">
                                                <button disabled={!formik.values.dispatch_status_id} type="button" onClick={() => downLoadSample(subStatusOptions?.status?.[formik.values.dispatch_mode_id]?.[formik.values.status], formik.values.dispatch_status_id)}
                                                    className="btn btn-lg w-100 btn-primary p-3 px-6 align-self-center text-nowrap">
                                                    <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-2' />
                                                    Download Sample File
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">Remarks</label>
                                        <div className="col-lg-12 fv-row">
                                            <textarea
                                                name="status_remarks"
                                                className={clsx(
                                                    'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                    { 'is-invalid': formik.touched.status_remarks && formik.errors.status_remarks },
                                                    { 'is-valid': formik.touched.status_remarks && !formik.errors.status_remarks, }
                                                )}
                                                placeholder="Type Remarks"
                                                onChange={formik.handleChange}
                                            >
                                            </textarea>
                                            {formik.touched.status_remarks && formik.errors.status_remarks ? (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span className='text-danger' role='alert'>{formik.errors.status_remarks}</span>
                                                    </div>
                                                </div>
                                            ) : <div className="text-muted fs-7"></div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*end::Card body*/}
                        <div className='card-footer py-2'>
                            <div className="d-flex justify-content-end">
                                {/*begin::Button*/}

                                <button type="submit" className="btn btn-primary"
                                    disabled={loader}>
                                    <span className="indicator-label">{formik?.values?.id ? "Submit" : "Submit"}</span>
                                    {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                                </button>
                                {/*end::Button*/}
                            </div>
                        </div>
                    </form>
                </div>


            </Modal.Body >

        </Modal >
    </>
    )
}

export { UploadFileForm }